export default function buildTrackedLink(baseUrl: string, utmCampaign: string): string {
  const url = new URL(baseUrl);

  url.searchParams.set('utm_source', 'personal');
  url.searchParams.set('utm_campaign', utmCampaign);

  return url.toString();
}
